import { all, call, put, take, takeEvery } from 'redux-saga/effects'
import * as actions from '../actions'
import * as actionTypes from '../actionTypes'
import { PaymentTerminal } from './paymentTerminal'

export default function* paymentTerminalSagas() {
    const paymentTerminal = new PaymentTerminal()

    function* connect() {
        if (paymentTerminal.isConfigured()) {
            yield call(paymentTerminal.connect)
        }
    }

    function* disconnect() {
        yield call(paymentTerminal.disconnect)
    }

    function* sendRequest(action) {
        if (paymentTerminal.matchTerminal(action.terminalId, action.terminalType)) {
            yield call(paymentTerminal.sendRequest, action.request.method, action.request.params)
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function* configure(action: { type: string, config: { apiUrl: any } }) {
        yield call(paymentTerminal.configure, action.config)
    }

    function* watchConfigure() {
        yield takeEvery(actionTypes.PAYMENT_TERMINAL_CONFIGURE, (action: any) => paymentTerminal.configure(action.config))
    }

    function* watchConnect() {
        yield takeEvery(actionTypes.PAYMENT_TERMINAL_CONNECT, connect)
    }

    function* watchDisconnect() {
        yield takeEvery(actionTypes.PAYMENT_TERMINAL_DISCONNECT, disconnect)
    }

    function* watchEvents() {
        try {
            const channel = yield call(paymentTerminal.createEventChannel)

            while (true) {
                const action = yield take(channel)
                yield put(action)
            }
        } finally {
            yield put(actions.error('Payment terminal event channel terminated', null))
        }
    }

    function* watchSendRequest() {
        yield takeEvery(actionTypes.PAYMENT_TERMINAL_SEND_REQUEST, sendRequest)
    }

    yield all([
        watchConfigure(),
        watchConnect(),
        watchDisconnect(),
        watchEvents(),
        watchSendRequest(),
    ])
}
